import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environment/environment';

export type CprngEndpointAccessTier =
  | 'public'
  | 'everyone'
  | 'authenticated_roles'
  | 'misconfigured';

export interface CprngEndpointRow {
  method: string;
  path: string;
  handler: string;
  requires_login: boolean;
  roles: string[];
  groups: string[];
  access_tier: CprngEndpointAccessTier;
  access_sort: number;
}

/**
 * Superadmin endpoint registry snapshot.
 * GET /cprng/endpoints
 */
export function cprng_endpoints(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'cprng_endpoints',
    description: 'Registered API routes with access tier (superadmin)',
    execute: (
      _params?: LoadDataParams
    ): Observable<{ items: CprngEndpointRow[] }> => {
      return service.http
        .get<{ items: CprngEndpointRow[] }>(
          `${environment.apiUrl}/cprng/endpoints`,
          { withCredentials: true }
        )
        .pipe(map((res) => ({ items: res.items ?? [] })));
    },
  };
}
